import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getRuleExecutions, listRuleExecutionFilters } from "./actions";

export const ruleExecutionEntityAdapter = createEntityAdapter({
  selectId: (rule) => rule.ruleId,
});

const initialState = ruleExecutionEntityAdapter.getInitialState({
  totalCount: 0,
  modals: {},
  lastExecutionTime: 0,
  filters: [],
});

export const ruleExecutionSlice = createSlice({
  name: "ruleExecution",
  initialState: initialState,

  extraReducers: (builder) => {
    builder.addCase(getRuleExecutions.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        const lastExecution = action.payload.executions.reduce((last, current) => {
          return Math.max(last, new Date(current.triggerTime).getTime());
        }, new Date("1970-01-01T00:00:00.000Z").getTime());

        ruleExecutionEntityAdapter.upsertMany(state, action.payload.executions);
        state.lastExecutionTime = lastExecution;
      } else {
        state.entities = {};
      }
    });
    builder.addCase(listRuleExecutionFilters.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        state.filters = action.payload?.filters;
      } else {
        state.filters = [];
      }
    });
  },
});

export default ruleExecutionSlice.reducer;
